<template>
  <el-dialog
    class="dialogLinkGroupInfo"
    width="400px"
    :close-on-click-modal="false"
    :visible="true"
    @close="$emit('close')">
    <div
      slot="title"
      class="px-12 py-3 font-16 fw-700">
      Thông tin nhóm
    </div>
    <el-divider class="m-0" />
    <div class="d-flex flex-column align-items-center mt-3">
      <el-image
        style="min-width: 80px; max-width: 80px; min-height: 80px; max-height: 80px; border-radius: 40px"
        :src="groupInfo?.avatar || '/assets/images/no-avatar.png'"
        lazy></el-image>
      <span class="fw-700 font-16 my-2">{{ groupInfo?.name }}</span>
      <span>
        {{ groupInfo.currentMems ? groupInfo.currentMems.length : 0 }} thành viên. Tạo bởi
        <span class="text-blue400">{{ createUser ? createUser.zaloName : "" }}</span>
      </span>
      <el-divider class="my-2" />
      <div class="px-12 text-center">Bạn đang ở hàng chờ. Hãy tham gia chat để cùng trò chuyện với mọi người trong nhóm.</div>
      <div
        v-if="groupInfo.currentMems?.length"
        class="d-flex py-2">
        <img
          class="avatar"
          style=""
          :src="groupInfo.currentMems[0].avatar || '/assets/images/no-avatar.png'" />
        <img
          v-if="groupInfo.currentMems[1]"
          class="avatar"
          style="margin-left: -0.75rem"
          :src="groupInfo.currentMems[1].avatar || '/assets/images/no-avatar.png'" />
        <img
          v-if="groupInfo.currentMems[2]"
          class="avatar"
          style="margin-left: -0.75rem"
          :src="groupInfo.currentMems[2].avatar || '/assets/images/no-avatar.png'" />
        <div
          class="avatar d-flex align-items-center justify-content-center"
          style="background-color: #e9edf0; margin-left: -0.75rem">
          <IconV2
            name="v2-more_horiz"
            size="20px" />
        </div>
      </div>
    </div>
    <el-divider class="my-2" />
    <div class="d-flex justify-content-end px-12 py-2">
      <el-button
        size="md"
        @click="$emit('close')">
        Đóng
      </el-button>
      <el-button
        type="primary"
        size="md"
        :disabled="groupInfo.groupId?false:true"
        @click="clickJoinGroup">
        Tham gia
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: ["accountId", "link"],
  data() {
    return {
      groupInfo: {},
    };
  },
  computed: {
    createUser() {
      if (!this.groupInfo.creatorId) return null;
      const user = this.groupInfo.currentMems.find((u) => u.id == this.groupInfo.creatorId);
      return user;
    },
  },
  methods: {
    searchGroupByLink() {
      if (!this.accountId || !this.link) return;
      this.$http
        .get(`/api/message/getGroupInfoByLink?accountId=${this.accountId}&link=${this.link}`)
        .then((resp) => {
          console.log("🚀 ~ .then ~ resp:", resp.data.data);
          this.groupInfo = resp.data.data;
        })
        .catch(() => {
          this.groupInfo = {};
        });
    },
    clickJoinGroup() {
      this.$http
        .get(`/api/message/joinGroupFromLink?accountId=${this.accountId}&link=${this.link}`)
        .then((resp) => {
          this.alert("success", resp.data.error_message);
          this.$emit("close");
        })
        .catch(() => {
          this.groupInfo = {};
        });
    },
  },
  created() {
    this.searchGroupByLink();
  },
};
</script>

<style lang="scss" >
.dialogLinkGroupInfo {
  .el-dialog__body {
    padding: 0 !important;
  }
  .el-dialog__header {
    padding: 0 !important;
  }
  .avatar {
    min-width: 40px;
    max-width: 40px;
    min-height: 40px;
    max-height: 40px;
    border-radius: 20px;
    border: 2px solid white;
  }
}
</style>